export const UserTypeConstant = ["Super Admin"];